// Numero WhatsApp reale El Mastro
export const WHATSAPP_NUMBER = "393519429314";
export const PHONE_NUMBER_TEL = "+393519429314";
export const PHONE_DISPLAY = "+39 351 942 9314";
export const EMAIL = "info@elmastro.it";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const WA_DEFAULT_MSG =
  "Ciao El Mastro! Ho bisogno di un intervento a Napoli. Vi invio il video del guasto.";
export const WA_BNB_MSG =
  "Ciao El Mastro! Sono un gestore B&B / property manager e vorrei richiedere la convenzione.";
export const WA_CONDO_MSG =
  "Ciao El Mastro! Sono un amministratore di condominio e vorrei richiedere la convenzione.";
export const WA_SUBSCRIBER_MSG =
  "Ciao El Mastro, sono un abbonato! Ho un'urgenza presso la mia struttura/condominio in via [Inserisci Indirizzo]. Invio video del guasto.";

export const ZONES = [
  "Centro Storico",
  "Quartieri Spagnoli",
  "Chiaia",
  "Vomero",
  "Posillipo",
  "Fuorigrotta",
  "Toledo",
  "Garibaldi",
];
